<div class="valuation-tab-container">
  <div class="valuation-tab-top-action-container">
    <div class="valuation-filter-container">
      <div class="valuation-filter">
        <div class="valuation-ratio-box">
          <app-lineitem-filter
            [options]="ratioLineItemsData"
            [selectedValue]="{}"
            [selectedOptionsId]="selectedRatioId"
            liFilterId="valuationCompanyLI"
            [bottomBorderView]="true"
            [disabled]="
              !isMetaReady ||
              isUserSettingsInProgress ||
              !state ||
              !isLineItemDataReady
            "
            placeholder="&nbsp;Add Ratios"
            label="Ratios"
            [showButton]="true"
            (onValueChange)="onSearchedLi($event)"
            (onEditButtonClick)="handleEditLineItemsButtonClick()"
          ></app-lineitem-filter>
        </div>
      </div>
      <div class="valuation-filter">
        <va-period-filter
          [filterWidthVariation]="3"
          [periodData]="state ? state.period : undefined"
          [disabled]="
            !isMetaReady || isUserSettingsInProgress || !state || !state.period
          "
          (onApply)="handlePeriodApply($event)"
          [dataAvailable]="periodsWithAvailableData"
        ></va-period-filter>
      </div>
      <div class="valuation-filter">
        <va-currency-select
          size="small"
          selectWidth="78"
          labelPlacement="top"
          [bottomBorderView]="true"
          [selectedCurrency]="currency"
          [apiEP]="apiEP"
          apiUrl="/api/get_available_currencies"
          (onChange)="updateCurrency($event)"
          [disabled]="
            !isMetaReady || currencyUpdating || isUserSettingsInProgress
          "
        ></va-currency-select>
      </div>
    </div>

    <div class="valuation-cta-right-section">
      <app-export-to-excel-dropdown
        [(isPopoverVisible)]="isExportPopoverVisible"
        [disabled]="!isMetaReady || isUserPeriodCalSettingsInProgress"
        [optionList]="excelToExportDropdownOptions"
        [isExportInProgress]="isExportInProgress"
        (onListItemClick)="handleETEListItemClick($event)"
      ></app-export-to-excel-dropdown>
    </div>
  </div>
  <div class="grid-section" style="padding-top: 16px">
    <app-valuation-grid
      [gridData]="gridData"
      [showAverage]="false"
      [showMedian]="false"
      [tabType]="tabType"
      [orientation]="orientationValue"
      [ratioList]="ratioList"
      [currentTicker]="currentTicker"
      [highlightGAAP]="highlightGAAP"
      [visible]="visible"
      [isDataInProgress]="isDataInProgress"
      [periodState]="state ? state.period : undefined"
    ></app-valuation-grid>
  </div>
</div>
